import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apply, JobSearch } from "../../../Constant";
import Sidebar from "../Common";
import JobApply from "./Form";

const JobApplyCotainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Apply} parent={JobSearch} title={Apply} />
      <Container fluid>
        <Row>
          <Col xl="3" className="xl-40 box-col-4e">
            <div className="md-sidebar">
              <Sidebar />
            </div>
          </Col>
          <Col xl="9" className="xl-60 box-col-8">
            <JobApply />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default JobApplyCotainer;
